import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logged_user: {},
  users: {},
  agencies: {},
  allOrganizations: {},
  gameOffers: {},
  allGameOffersActive: {},
  providers: [],
  raffleLotteries: {},
  raffleGameOffers: {},
  gameMode: {},
  organizationAgencies: {},
  concentratorSelectedRedux: [],
  organizationAgenciesSearch: {},
  roles: {},
  salePoints: {},
  lottery: {},
  activeOrganization: "",
  taxConditions: [],
  appConfig: [],
  raffles: {},
  organizationsPackage: {},
  noaOrganization: {},
};

const gammaSlice = createSlice({
  name: "apiCalls",
  initialState,
  reducers: {
    loggedUser(state, action) {
      state.logged_user = action.payload;
    },
    sliceOrganizationPackage(state, action) {
      state.organizationsPackage = action.payload;
    },
    usersUpdate(state, action) {
      state.users = action.payload;
    },
    agenciesUpdate(state, action) {
      state.agencies = action.payload;
    },
    gameOffersUpdate(state, action) {
      state.gameOffers = { ...action.payload, content: action.payload.content };
    },
    addGameOffers(state, action) {
      state.gameOffers = {
        content: [...state.gameOffers.content, action.payload],
      };
    },
    setAllGameOffersActive(state, action) {
      state.allGameOffersActive = action.payload;
    },
    replaceGameOffers(state, action) {
      const index = state.gameOffers.content.findIndex(
        (game) => game.id === action.payload.id && true,
      );
      const content = state.gameOffers.content;
      content[index] = action.payload;
      state.gameOffers = { content: [...content] };
    },
    gameModeUpdate(state, action) {
      state.gameMode = action.payload;
    },
    raffleGameOffersUpdate(state, action) {
      state.raffleGameOffers = action.payload;
    },
    setConcentratorSelectedRedux(state, action) {
      state.concentratorSelectedRedux = action.payload;
    },
    lotteryUpdate(state, action) {
      state.lottery = action.payload;
    },
    organizationAgenciesUpdate(state, action) {
      state.organizationAgencies = action.payload;
    },
    organizationsAgenciesToSearchBar(state, action) {
      state.organizationAgenciesSearch = action.payload;
    },
    organizationAgenciesUpdateAfterEdit(state, action) {
      state.organizationAgencies = {
        ...state.organizationAgencies,
        content: [...action.payload],
      };
    },
    allRolesUpdate(state, action) {
      state.roles = action.payload;
    },
    allSalePointsUpdate(state, action) {
      state.salePoints = action.payload;
    },
    allOrganizations(state, action) {
      state.allOrganizations = action.payload;
    },
    setActiveOrganization(state, action) {
      state.activeOrganization = action.payload;
    },
    resetLoggedUser(state, action) {
      state.logged_user = {};
    },
    setProviders(state, action) {
      state.providers = action.payload.filter((p) => p.enabled);
    },
    allRaffleLotteries(state, action) {
      state.raffleLotteries = action.payload;
    },
    appConfigLoader(state, action) {
      state.appConfig = action.payload;
    },
    setNoaOrganization(state, action) {
      state.noaOrganization = action.payload;
    },
    resetNoaOrganization(state, action) {
      state.noaOrganization = {};
    },
    resetGammaSlice(state, action) {
      state.logged_user = {};
      state.users = {};
      state.users_login = [];
      state.agencies = {};
      state.allOrganizations = [];
      state.gameOffers = [];
      state.organizationAgencies = {};
      state.organizationAgenciesSearch = {};
      state.concentratorSelectedRedux = [];
      state.roles = {};
      state.salePoints = {};
      state.movements = {};
      state.imputations = [];
      state.activeOrganization = "";
      state.accountingCodeKinds = {};
      state.appConfig = [];
      state.agencySettlemeng = [];
      state.homologated_Games = [];
      state.organization_Configuration = {};
      state.organizationsPackage = {};
      state.noaOrganization = {};
    },
    updateTaxCondition(state, action) {
      state.taxConditions = action.payload;
    },
    setRaffles(state, action) {
      state.raffles = action.payload;
    },
  },
});

export const {
  usersUpdate,
  agenciesUpdate,
  gameOffersUpdate,
  raffleGameOffersUpdate,
  replaceGameOffers,
  setAllGameOffersActive,
  organizationsAgenciesToSearchBar,
  organizationAgenciesUpdate,
  organizationAgenciesUpdateAfterEdit,
  allRolesUpdate,
  allSalePointsUpdate,
  setConcentratorSelectedRedux,
  allOrganizations,
  allRaffleLotteries,
  setActiveOrganization,
  gameModeUpdate,
  lotteryUpdate,
  addGameOffers,
  loggedUser,
  resetLoggedUser,
  setProviders,
  appConfigLoader,
  updateTaxCondition,
  setRaffles,
  sliceOrganizationPackage,
  resetGammaSlice,
  setNoaOrganization,
  resetNoaOrganization,
} = gammaSlice.actions;

export default gammaSlice.reducer;
